(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer"] && !Shopify.designMode) return;
  try {
    (() => {
  const groups = document.querySelectorAll('.milanus-footer-v2 .mf-group');
  const sync = () => groups.forEach((group) => {
    if (window.matchMedia('(min-width: 768px)').matches) group.open = true;
    else group.open = false;
  });
  sync();
  window.addEventListener('resize', sync, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["milanus-approved-category-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){var link=event.target.closest('.milanus-category-menu summary a');if(link){event.stopPropagation();}});
(function(){
  var storageKey='milanus:last-category-drawer:'+(document.documentElement.lang||'en');
  function topLevelDrawers(menu){return menu.querySelectorAll(':scope > .milanus-category-menu__groups > .milanus-category-menu__group > details');}
  function restore(menu){
    var savedIndex='';
    try{savedIndex=sessionStorage.getItem(storageKey)||'';}catch(error){}
    if(savedIndex==='')return;
    topLevelDrawers(menu).forEach(function(details,index){details.open=String(index)===savedIndex;});
  }
  function initialize(){
    document.querySelectorAll('.milanus-category-menu').forEach(function(menu){
      if(menu.dataset.drawerStateReady==='true')return;
      menu.dataset.drawerStateReady='true';
      restore(menu);
    });
  }
  document.addEventListener('toggle',function(event){
    var current=event.target;
    if(!(current instanceof HTMLDetailsElement)||!current.open)return;
    var menu=current.closest('.milanus-category-menu');
    if(!menu||current.classList.contains('milanus-category-menu__mobile-shell'))return;
    var group=current.parentElement;
    var groups=group&&group.parentElement;
    if(!group||!group.classList.contains('milanus-category-menu__group')||!groups||!groups.classList.contains('milanus-category-menu__groups'))return;
    var drawers=Array.prototype.slice.call(topLevelDrawers(menu));
    var index=drawers.indexOf(current);
    if(index<0)return;
    try{sessionStorage.setItem(storageKey,String(index));}catch(error){}
  },true);
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initialize);}else{initialize();}
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["milanus-card-gallery"] && !Shopify.designMode) return;
  try {
    const gallerySelector = '.mc-card__media[data-mc-gallery]';
  const mobileImages = window.matchMedia('(max-width: 767px), (hover: none) and (pointer: coarse)');
  const mouseImages = window.matchMedia('(hover: hover) and (pointer: fine)');
  const galleryStates = new WeakMap();
  let activeSwipe = null;
  let warmupStarted = false;
  let galleryWarmup = Promise.resolve();
  const warmedGalleries = new WeakSet();

  function findGallery(target) {
    return target instanceof Element ? target.closest(gallerySelector) : null;
  }

  function paintGallery(state) {
    const index = state.enabled && state.loaded && state.wanted === 1 ? 1 : 0;
    state.gallery.dataset.mcGalleryIndex = String(index);
    state.primary.setAttribute('aria-hidden', String(index === 1));
    if (state.secondary) state.secondary.setAttribute('aria-hidden', String(index === 0));
    state.button.setAttribute('aria-label', index === 1 ? state.button.dataset.labelPrevious : state.button.dataset.labelNext);
    state.button.hidden = !state.enabled || !mobileImages.matches || state.failed;
  }

  function getGalleryState(gallery) {
    if (!gallery) return null;
    let state = galleryStates.get(gallery);
    if (state) return state;
    const primary = gallery.querySelector('.mc-card__image--primary');
    const link = gallery.querySelector('.mc-card__image-link');
    const button = gallery.querySelector('[data-mc-gallery-toggle]');
    if (!primary || !primary.dataset.secondarySrc || !link || !button) return null;
    state = { gallery, primary, link, button, secondary: null, loaded: false, failed: false, promise: null, wanted: 0, enabled: false, hovering: false, focused: false, blockClickUntil: 0 };
    galleryStates.set(gallery, state);
    refreshGallery(state);
    return state;
  }

  function refreshGallery(state) {
    state.enabled = state.gallery.dataset.mcGallery === 'catalog' || mobileImages.matches;
    state.gallery.dataset.mcGalleryEnabled = String(state.enabled);
    state.gallery.dataset.mcGalleryTouch = String(mobileImages.matches);
    if (!state.enabled) state.wanted = 0;
    paintGallery(state);
  }

  function ensureSecondary(state) {
    if (state.failed || !state.enabled) return Promise.resolve(false);
    if (state.promise) return state.promise;
    state.gallery.setAttribute('aria-busy', 'true');
    state.promise = new Promise(resolve => {
      const image = document.createElement('img');
      state.secondary = image;
      image.className = 'mc-card__image mc-card__image--secondary';
      image.width = Number(state.primary.dataset.secondaryWidth) || 600;
      image.height = Number(state.primary.dataset.secondaryHeight) || 600;
      image.alt = state.primary.dataset.secondaryAlt || state.primary.alt;
      image.loading = 'eager';
      image.fetchPriority = 'low';
      image.decoding = 'async';
      image.draggable = false;
      image.setAttribute('aria-hidden', 'true');
      let settled = false;
      async function loaded() {
        if (settled) return;
        settled = true;
        if (image.decode) await image.decode().catch(() => {});
        state.loaded = true;
        state.gallery.removeAttribute('aria-busy');
        paintGallery(state);
        resolve(true);
      }
      image.addEventListener('load', loaded, { once: true });
      image.addEventListener('error', () => {
        if (settled) return;
        settled = true;
        state.failed = true;
        state.wanted = 0;
        image.remove();
        state.gallery.dataset.mcGalleryError = 'true';
        state.gallery.removeAttribute('aria-busy');
        paintGallery(state);
        resolve(false);
      }, { once: true });
      image.sizes = state.primary.sizes;
      image.srcset = state.primary.dataset.secondarySrcset || '';
      image.src = state.primary.dataset.secondarySrc;
      state.link.appendChild(image);
      if (image.complete && image.naturalWidth > 0) loaded();
    });
    return state.promise;
  }

  function ensurePrimary(state) {
    if (!state || !state.primary || state.primary.complete) return Promise.resolve(true);
    state.primary.loading = 'eager';
    state.primary.fetchPriority = 'low';
    return new Promise(resolve => {
      let settled = false;
      function finish(result) {
        if (settled) return;
        settled = true;
        resolve(result);
      }
      state.primary.addEventListener('load', () => finish(true), { once: true });
      state.primary.addEventListener('error', () => finish(false), { once: true });
      window.setTimeout(() => finish(state.primary.complete), 8000);
    });
  }

  function waitForIdle(timeout) {
    return new Promise(resolve => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(resolve, { timeout });
      else window.setTimeout(resolve, Math.min(timeout, 500));
    });
  }

  async function warmBatch(states, loader, concurrency) {
    for (let index = 0; index < states.length; index += concurrency) {
      if (document.hidden) await new Promise(resolve => {
        document.addEventListener('visibilitychange', resolve, { once: true });
      });
      await Promise.all(states.slice(index, index + concurrency).map(loader));
      await waitForIdle(500);
    }
  }

  function scheduleWarmup(states, urgent = false) {
    const pending = states.filter(state => !warmedGalleries.has(state.gallery));
    if (!pending.length) return galleryWarmup;
    pending.forEach(state => warmedGalleries.add(state.gallery));
    const concurrency = mobileImages.matches ? 2 : 4;
    const run = async () => {
      if (!urgent) await waitForIdle(800);
      await warmBatch(pending.slice(0, 4), ensurePrimary, concurrency);
      await warmBatch(pending.slice(0, 4), ensureSecondary, concurrency);
      await warmBatch(pending.slice(4), ensurePrimary, concurrency);
      await warmBatch(pending.slice(4), ensureSecondary, concurrency);
    };
    if (urgent) {
      run().catch(() => {});
      return galleryWarmup;
    }
    galleryWarmup = galleryWarmup.then(run);
    return galleryWarmup;
  }

  function warmGalleryQueue() {
    if (warmupStarted) return galleryWarmup;
    warmupStarted = true;
    const states = Array.from(document.querySelectorAll(gallerySelector)).slice(0, 24).map(getGalleryState).filter(Boolean);
    return scheduleWarmup(states);
  }

  function warmAppendedGalleries() {
    warmGalleryQueue();
    const states = Array.from(document.querySelectorAll(gallerySelector)).slice(24, 48).map(getGalleryState).filter(Boolean);
    scheduleWarmup(states, true);
  }

  function showImage(state, index) {
    if (!state || !state.enabled || state.failed) return;
    state.wanted = index;
    if (index === 1) ensureSecondary(state);
    paintGallery(state);
  }

  function initializeGalleries(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element && root.matches(gallerySelector)) getGalleryState(root);
    root.querySelectorAll(gallerySelector).forEach(getGalleryState);
  }

  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || mobileImages.matches || !mouseImages.matches) return;
    const gallery = findGallery(event.target);
    if (!gallery || (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))) return;
    const state = getGalleryState(gallery);
    if (!state || !state.enabled) return;
    state.hovering = true;
    showImage(state, 1);
  }, { passive: true });

  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse' || mobileImages.matches) return;
    const gallery = findGallery(event.target);
    if (!gallery || (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))) return;
    const state = getGalleryState(gallery);
    if (!state) return;
    state.hovering = false;
    if (!state.focused) showImage(state, 0);
  }, { passive: true });

  document.addEventListener('focusin', event => {
    if (mobileImages.matches) return;
    const state = getGalleryState(findGallery(event.target));
    if (!state || !state.enabled) return;
    state.focused = true;
    showImage(state, 1);
  });

  document.addEventListener('focusout', event => {
    const gallery = findGallery(event.target);
    if (!gallery || (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))) return;
    const state = getGalleryState(gallery);
    if (!state) return;
    state.focused = false;
    if (!mobileImages.matches && !state.hovering) showImage(state, 0);
  });

  document.addEventListener('pointerdown', event => {
    if (!event.isPrimary) { activeSwipe = null; return; }
    const state = getGalleryState(findGallery(event.target));
    if (!state || !state.enabled) return;
    state.blockClickUntil = 0;
    if (!mobileImages.matches || event.button !== 0 || event.target.closest('[data-mc-gallery-toggle]')) return;
    activeSwipe = { state, id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
  }, { passive: true });

  document.addEventListener('pointermove', event => {
    if (!activeSwipe || event.pointerId !== activeSwipe.id) return;
    const dx = event.clientX - activeSwipe.x;
    const dy = event.clientY - activeSwipe.y;
    if (!activeSwipe.horizontal && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { activeSwipe = null; return; }
    if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      activeSwipe.horizontal = true;
      if (dx < 0) ensureSecondary(activeSwipe.state);
    }
  }, { passive: true });

  document.addEventListener('pointerup', event => {
    if (!activeSwipe || event.pointerId !== activeSwipe.id) return;
    const swipe = activeSwipe;
    activeSwipe = null;
    const dx = event.clientX - swipe.x;
    const dy = event.clientY - swipe.y;
    const threshold = Math.min(60, Math.max(32, swipe.state.gallery.clientWidth * .15));
    if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
    swipe.state.blockClickUntil = Date.now() + 700;
    showImage(swipe.state, dx < 0 ? 1 : 0);
  }, { passive: true });

  document.addEventListener('pointercancel', () => { activeSwipe = null; }, { passive: true });

  document.addEventListener('click', event => {
    const state = getGalleryState(findGallery(event.target));
    if (!state || !state.enabled) return;
    const toggle = event.target.closest('[data-mc-gallery-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      showImage(state, state.wanted === 1 ? 0 : 1);
      return;
    }
    if (state.blockClickUntil > Date.now() && event.detail !== 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      state.blockClickUntil = 0;
    }
  }, true);

  document.addEventListener('dragstart', event => {
    const state = getGalleryState(findGallery(event.target));
    if (state && state.enabled && mobileImages.matches) event.preventDefault();
  });

  function refreshAllGalleries() {
    activeSwipe = null;
    document.querySelectorAll(gallerySelector).forEach(gallery => {
      const state = getGalleryState(gallery);
      if (!state) return;
      state.wanted = 0;
      state.hovering = false;
      state.focused = false;
      refreshGallery(state);
    });
  }
  mobileImages.addEventListener('change', refreshAllGalleries);
  initializeGalleries(document);
  if (document.readyState === 'complete') window.setTimeout(warmGalleryQueue, 0);
  else window.addEventListener('load', warmGalleryQueue, { once: true });
  document.addEventListener('milanus:catalog-products-appended', warmAppendedGalleries);
  document.addEventListener('milanus:home-products-appended', warmAppendedGalleries);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(initializeGalleries));
  }).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["milanus-contact-page"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',function(){var form=document.getElementById('page_contact_form');if(!form)return;var question=form.querySelector('#PageContact-question');var answer=form.querySelector('#PageContact-answer');if(!question||!answer)return;var n1=Math.round(10*Math.random()+1);var n2=Math.round(10*Math.random()+1);question.value=n1+' + '+n2;form.addEventListener('submit',function(event){if(Number(answer.value)!==n1+n2){answer.value='';answer.focus();event.preventDefault()}})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["milanus-guides-hub"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    root.querySelectorAll('[data-hub-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-hub-track]');
      const previous = carousel.querySelector('[data-hub-previous]');
      const next = carousel.querySelector('[data-hub-next]');
      const distance = () => Math.max(track.clientWidth * 0.82, 240);
      previous.addEventListener('click', () => track.scrollBy({ left: -distance(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: distance(), behavior: 'smooth' }));
    });
  };
  const initialize = () => document.querySelectorAll('.milanus-hub').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["milanus-responsive-collection"] && !Shopify.designMode) return;
  try {
    function normalizeMilanusMinimum(form){
  if(!form||!form.matches('[data-milanus-enforced-minimum]'))return;
  const input=form.querySelector('input[name="quantity"]');
  const minimum=Number(form.dataset.milanusEnforcedMinimum||input&&input.min||1);
  if(input&&Number(input.value)<minimum)input.value=String(minimum);
}
document.addEventListener('click',event=>{
  const submit=event.target.closest&&event.target.closest('[data-milanus-enforced-minimum] button[type="submit"],[data-milanus-enforced-minimum] input[type="submit"]');
  if(submit)normalizeMilanusMinimum(submit.closest('form'));
},true);
document.addEventListener('submit',event=>normalizeMilanusMinimum(event.target),true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["milanus-seo-article"] && !Shopify.designMode) return;
  try {
    (() => { const init = (root) => root.querySelectorAll('.milanus-seo-product-drawer__controls').forEach((drawer) => { if (drawer.dataset.ready) return; drawer.dataset.ready = 'true'; const track = drawer.querySelector('[data-article-track]'); drawer.querySelectorAll('[data-article-scroll]').forEach((button) => button.addEventListener('click', () => track?.scrollBy({ left: Number(button.dataset.articleScroll) * Math.max(track.clientWidth * .85, 240), behavior: 'smooth' }))); }); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document); document.addEventListener('shopify:section:load', (event) => init(event.target)); })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["milanus-signup-dialog"] && !Shopify.designMode) return;
  try {
    (function(){
  var key='milanus_signup_dialog_seen_v1';
  function storageGet(){try{return sessionStorage.getItem(key)}catch(error){return null}}
  function storageSet(){try{sessionStorage.setItem(key,'1')}catch(error){}}
  function init(){
    var dialog=document.querySelector('[data-milanus-signup-dialog]');
    var previewMode='';
    if(window.location.hash==='#milanus-signup-form')previewMode='form';
    if(window.location.hash==='#milanus-signup-success')previewMode='success';
    if(window.location.hash==='#milanus-signup-failure')previewMode='failure';
    if(!dialog||(!previewMode&&storageGet()))return;
    var closeButtons=dialog.querySelectorAll('[data-milanus-signup-close]');
    var form=dialog.querySelector('[data-milanus-signup-form]');
    var countryCode=dialog.querySelector('[data-milanus-signup-country-code]');
    var phone=dialog.querySelector('[data-milanus-signup-phone]');
    var selectedCountryCode=dialog.querySelector('[data-milanus-signup-selected-country-code]');
    var submitButton=form.querySelector('button[type="submit"]');
    var successPanel=dialog.querySelector('[data-milanus-signup-success]');
    var errorPanel=dialog.querySelector('[data-milanus-signup-error]');
    var dismissButton=dialog.querySelector('[data-milanus-signup-dismiss]');
    var delay=parseInt(dialog.getAttribute('data-delay'),10)||120000;
    function close(){
      storageSet();
      document.documentElement.classList.remove('milanus-signup-open');
      if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');
    }
    function phoneDigits(){return phone.value.replace(/\D/g,'')}
    function normalizeCountryCode(){var digits=countryCode.value.replace(/\D/g,'').slice(0,3);countryCode.value='+'+digits;return digits}
    function validatePhone(){
      var digits=phoneDigits();
      var countryDigits=normalizeCountryCode();
      var valid=digits.length===0||(countryDigits.length>=1&&digits.length>=4&&countryDigits.length+digits.length<=15);
      phone.setCustomValidity(valid?'':dialog.getAttribute('data-phone-error'));
      return valid;
    }
    function showDialog(mode){
      if(mode==='success'){
        form.hidden=true;
        dialog.querySelector('.milanus-signup-dialog__header').hidden=true;
        successPanel.hidden=false;
      }
      if(mode==='failure'){
        errorPanel.textContent=dialog.getAttribute('data-error-text');
        errorPanel.hidden=false;
        dismissButton.textContent=dialog.getAttribute('data-continue-text');
      }
      document.documentElement.classList.add('milanus-signup-open');
      if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');
      if(mode==='form'||mode==='failure')window.setTimeout(function(){var email=dialog.querySelector('input[type="email"]');if(email)email.focus()},80);
    }
    for(var closeIndex=0;closeIndex<closeButtons.length;closeIndex++)closeButtons[closeIndex].addEventListener('click',close);
    dialog.addEventListener('cancel',function(event){event.preventDefault();close()});
    countryCode.addEventListener('focus',function(){countryCode.select()});
    countryCode.addEventListener('click',function(){countryCode.select()});
    countryCode.addEventListener('input',validatePhone);
    phone.addEventListener('input',validatePhone);
    form.addEventListener('submit',function(event){
      validatePhone();
      if(!form.checkValidity()){event.preventDefault();form.reportValidity();return}
      var digits=phoneDigits();
      selectedCountryCode.value=countryCode.value;
      if(digits.length)phone.value=countryCode.value+digits;
      event.preventDefault();
      errorPanel.hidden=true;
      submitButton.disabled=true;
      var originalText=submitButton.textContent;
      submitButton.textContent=dialog.getAttribute('data-loading-text');
      var callbackName='milanusMailchimp'+Date.now();
      var finished=false;
      var script=document.createElement('script');
      var timeoutId=window.setTimeout(function(){finish(false)},12000);
      function cleanup(){
        window.clearTimeout(timeoutId);
        try{delete window[callbackName]}catch(error){window[callbackName]=undefined}
        if(script.parentNode)script.parentNode.removeChild(script);
      }
      function finish(ok,message){
        if(finished)return;
        finished=true;
        cleanup();
        if(ok){
          form.hidden=true;
          dialog.querySelector('.milanus-signup-dialog__header').hidden=true;
          successPanel.hidden=false;
          storageSet();
          window.setTimeout(close,2500);
          return;
        }
        submitButton.disabled=false;
        submitButton.textContent=originalText;
        errorPanel.textContent=message||dialog.getAttribute('data-error-text');
        errorPanel.hidden=false;
        dismissButton.textContent=dialog.getAttribute('data-continue-text');
      }
      window[callbackName]=function(response){
        var message=response&&response.msg?String(response.msg):'';
        var alreadySubscribed=/already subscribed/i.test(message);
        finish(Boolean(response&&response.result==='success')||alreadySubscribed,message);
      };
      var data=new URLSearchParams(new FormData(form));
      data.set('c',callbackName);
      script.src=form.action.replace('/subscribe/post?','/subscribe/post-json?')+'&'+data.toString();
      script.onerror=function(){finish(false)};
      document.head.appendChild(script);
    });
    if(previewMode){
      showDialog(previewMode);
    }else{
      window.setTimeout(function(){
        if(storageGet())return;
        storageSet();
        showDialog('form');
      },delay);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

})();
